module.exports = __webpack_public_path__ + "static/img/医嘱与病历_场景四.206005f3.png";